module.exports = __webpack_public_path__ + "img/progress7.d941ab35.png";